const packetaParcelItems = document.querySelectorAll<HTMLElement>(".i-packeta-parcel")

packetaParcelItems.forEach((item) => {
  const radio = item.closest(".f-radio-box")
  const radioInput = radio?.querySelector<HTMLInputElement>(".f-radio-box__input")
  const hiddenInputs = document.querySelectorAll<HTMLInputElement>(".f-radio-box__parcel-hidden-input")
  const resultInput = radio?.querySelector<HTMLInputElement>(".f-radio-box__parcel-hidden-input input")
  const packetaApiKey = item.dataset.packetaApi
  const packetaOptions = JSON.parse(item.dataset.packetaOptions ?? "")
  const countrySelect = document.querySelector<HTMLSelectElement>(".s-shipping-payment__country-select select")
  const changeParcelLink = radio?.querySelector(".f-radio-box__link")

  const disableIframeHiddenInputs = () => {
    hiddenInputs.forEach((input) => (input.disabled = true))
  }

  const setResultInputValue = (value: string) => {
    disableIframeHiddenInputs()
    resultInput.disabled = false
    resultInput.value = value
  }

  const packetaCallback = (point) => {
    item.classList.add("d-none")
    changeParcelLink?.classList.add("--hidden")
    if (radioInput) {
      radioInput.checked = false
    }

    if (point) {
      changeParcelLink?.classList.remove("--hidden")
      item.classList.remove("d-none")
      if (radioInput) {
        radioInput.checked = true
      }

      if (resultInput) {
        const packetaInfo = {
          id: point.id,
          name: point.name,
          place: point.place,
          street: point.street,
          city: point.city,
          zip: point.zip,
        }
        setResultInputValue(JSON.stringify(packetaInfo))
      }

      const packetaInfo: packetaOptions = {
        name: point.place as string,
        city: point.city as string,
        zip: point.zip as string,
        address: point.nameStreet as string,
        opening: point.openingHours.tableLong as string,
        description: point.directions,
        img: point.photo[0].normal,
      }
      setPacketaValues(item, packetaInfo)
    }

    radioInput.dispatchEvent(new Event("change"))
  }

  radio?.addEventListener("click", () => {
    const country = countrySelect ? countrySelect.selectedOptions[0].value : ""
    if (country) packetaOptions.country = country.toLowerCase()

    if (item.classList.contains("d-none")) {
      Packeta.Widget.pick(packetaApiKey, packetaCallback, packetaOptions)
    } else if (radioInput) {
      radioInput.checked = true
      radioInput.dispatchEvent(new Event("change"))
    }
  })

  changeParcelLink?.addEventListener("click", (e) => {
    e.preventDefault()
    Packeta.Widget.pick(packetaApiKey, packetaCallback, packetaOptions)
  })

  countrySelect?.addEventListener("change", () => {
    disableIframeHiddenInputs()
    setResultInputValue("")
    setPacketaValues(item, null, true)
    item.classList.add("d-none")
    changeParcelLink?.classList.add("--hidden")
  })
})

export const setPacketaValues = (item: HTMLElement, packetaOptions: packetaOptions, clear = false) => {
  const nameElement = item.querySelector<HTMLElement>(".i-packeta-parcel__name")
  const cityElement = item.querySelector<HTMLElement>(".i-packeta-parcel__city")
  const zipElement = item.querySelector<HTMLElement>(".i-packeta-parcel__zip")
  const addressElement = item.querySelector<HTMLElement>(".i-packeta-parcel__address")
  const openingElement = item.querySelector<HTMLElement>(".i-packeta-parcel__opening-hours-table")
  const descriptionElement = item.querySelector<HTMLElement>(".i-packeta-parcel__description")
  const imgElement = item.querySelector<HTMLImageElement>(".i-packeta-parcel__image img")

  if (clear) {
    if (nameElement) nameElement.innerHTML = ""
    if (cityElement) cityElement.innerHTML = ""
    if (zipElement) zipElement.innerHTML = ""
    if (addressElement) addressElement.innerHTML = ""
    if (openingElement) openingElement.innerHTML = ""
    if (descriptionElement) descriptionElement.innerHTML = ""
    if (imgElement) imgElement.src = ""
    return
  }

  if (nameElement) nameElement.innerHTML = packetaOptions.name
  if (cityElement) cityElement.innerHTML = packetaOptions.city
  if (zipElement) zipElement.innerHTML = packetaOptions.zip
  if (addressElement) addressElement.innerHTML = packetaOptions.address
  if (openingElement) openingElement.innerHTML = packetaOptions.opening
  if (descriptionElement) descriptionElement.innerHTML = packetaOptions.description
  if (imgElement) imgElement.src = packetaOptions.img
}

export type packetaOptions = {
  name: string
  city: string
  zip: string
  address: string
  opening: string
  description: string
  img: string
}
